// extracted by mini-css-extract-plugin
export default {"container":"CustomDropzone_container__A5Llj","content":"CustomDropzone_content__+8rc8"};